export class Alphabetical
{
    constructor(toplist, nav)
    {
        this.toplist = toplist;

        const buttons = nav.querySelectorAll('*');

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                for(let button of buttons) {
                    button.classList.remove('toplist-alphabet__character--active');
                }

                button.classList.add('toplist-alphabet__character--active');

                this.toplist.settings.filters = {
                    'name': {
                        'letter': button.innerHTML.toLowerCase()
                    }
                };
                this.toplist.settings.page = 1;

                this.timeOut = setTimeout(() => {
                    this.toplist.settingsChanged = true;
                    this.toplist.fetchToplist(this.toplist.settings);

                    clearTimeout(this.timeOut);
                }, 300);
            });
        });
    }
}